module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/role03-a9d8a0d3e881120673e8293e31a115d9.png";